import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserInfoService } from 'src/app/shared/services/user-info.service';

/**
 * Only super admins may open the master data, everybody else is sent to their tasks.
 */
export const masterDataGuard: CanActivateFn = async () => {
  const userInfoService = inject(UserInfoService);
  const router = inject(Router);

  // The app initializer loads the user, unless it wasn't logged in yet.
  if (!userInfoService.currentUser()) {
    try {
      await userInfoService.loadCurrentUser();
    } catch {
      return router.createUrlTree(['/my-tasks']);
    }
  }

  return userInfoService.isSuperAdmin() ? true : router.createUrlTree(['/my-tasks']);
};
